import React from "react";
import {CreatePaymentTokenOptions} from "../../../../../../stripe/model/CreatePaymentTokenOptions";
import {StripeCardElement} from "@stripe/stripe-js";
import {PaymentForm} from "../../../../model/PaymentForm";
import {EventTypeHolder, EventUtil} from "../../../../../../util/EventUtil";
import {PrePaymentSubmitButton} from "../../pre-payment-submit-button/PrePaymentSubmitButton";
import {StripeServiceSingleton} from "src/Context";
import {FeeOptionKey} from "../../../../../loan-details/component/FeeSelector";

interface Props {
    form: React.RefObject<PaymentForm>;
    cardElement?: StripeCardElement;
    submitButtonDisabled: boolean;
    errorCallback: (message: string) => void;
    selectedFees?: FeeOptionKey[];
}

export class PrePaymentCreditCardSubmitButton extends React.Component<Props> {

    private readonly stripeService = StripeServiceSingleton;

    private sendPaymentRequest = (): Promise<void> => {
        const options = this.getTokenOptions(this.props.selectedFees);

            const card = this.props.cardElement as StripeCardElement;
            return this.stripeService
                .confirmCardPayment(card, options)
                .then(result => {
                    if (result.error?.message) throw result.error.message;
                })
                .catch(err => {
                    EventUtil.fireEvent(EventTypeHolder.paymentFailure, err);
                    return Promise.reject(err);
                });
    };

    private getTokenOptions = (selectedFees?: FeeOptionKey[]): CreatePaymentTokenOptions => {
        let form = this.props.form.current as PaymentForm | null;
        return {
            name: form?.nameOnCard?.value || '',
            agreedToTerms: form?.agreedToTerms?.checked ?? false,
            selectedFees
        };
    }

    render() {
        return (
            <>
                <PrePaymentSubmitButton
                    sendPaymentRequest={this.sendPaymentRequest}
                    submitButtonDisabled={this.props.submitButtonDisabled}
                />
            </>
        );
    }
}
